import { articulationSchema } from 'schemas/articulation';
import { formSchemaSchema } from 'schemas/form-schema';
import { precedentSchema } from 'schemas/precedent';
import { sourceInstitutionSchema } from 'schemas/source-institution';
import { z } from 'zod';

const metadaCountsSchema = z.object({
  articulations: z.number(),
  precedents: z.number(),
  sourceInstitutions: z.number(),
});

const metadataSchema = z.object({
  previousRecords: metadaCountsSchema.nullable(),
  previousTimestamp: z.number().nullable(),
  records: metadaCountsSchema,
  timestamp: z.number(),
});

export const referenceDataSchema = z.object({
  articulations: z.array(articulationSchema),
  metadata: metadataSchema,
  precedents: z.array(precedentSchema),
  sourceInstitutions: z.array(sourceInstitutionSchema),
  formSchema: formSchemaSchema,
});
